<template>
  <div>
    <vs-popup :active.sync="popUpCreate" title="Confirmation">
      <div class="p-4">
        <p align="center">
            Are you are sure you want to continue without a Sage ID ?
        </p>
        <br />
        <div class="flex justify-end gap-2">
            <vs-button size="lg" color="primary" @click="saveSupplier">
                Yes, Continue!
            </vs-button>
            <vs-button size="lg" color="danger" @click="popUpCreate = false">Cancel</vs-button>
        </div>
      </div>
    </vs-popup>
    <vs-card>
      <div slot="header" class="flex justify-end" v-if="!isCreate">
        <div class="flex gap-2">
          <vs-button class="py-2 px-3" @click="onSave()">Save</vs-button>
          <vs-button class="py-2 px-3" @click="handleCancel" type="border">Cancel</vs-button>
        </div>
      </div>
      <vs-form autocomplete="off">
        <div class="custom-form">
          <div class="mb-4">
            <h6 class="font-bold">Supplier details</h6>
          </div>
          <vs-row vs-align="flex-start" vs-type="flex" vs-justify="left" vs-w="12">
            <vs-col vs-w="4">
              <vs-input :success="!errors.first('basic.name') && supplierData.name != ''" val-icon-success="done"
                val-icon-danger="error" :danger="errors.first('basic.name')" v-validate="'required'"
                name="name" data-vv-as="Supplier name" label="Supplier Name" class="custom-input w-full"
                data-vv-scope="basic" :danger-text="errors.first('basic.name')" v-model="supplierData.name" />
            </vs-col>
          </vs-row>
          <vs-row vs-align="flex-start" vs-type="flex" vs-justify="left" vs-w="12">
            <vs-col vs-w="4">
              <vs-input v-validate="'required'" name="email" data-vv-as="Email" label="Supplier orders email addresses"
                class="custom-input w-full" data-vv-scope="basic" :danger-text="errors.first('basic.email')"
                v-model="supplierData.email" val-icon-danger="error" :danger="errors.first('basic.email')"
                :success="!errors.first('basic.email') && supplierData.name != ''" val-icon-success="done" />
            </vs-col>
          </vs-row>
          <vs-row vs-align="flex-start" vs-type="flex" vs-justify="left" vs-w="12">
            <vs-col vs-w="4">
              <vs-input name="contactNumber" data-vv-as="Contact number" label="Supplier contact # (optional)"
                class="custom-input w-full" data-vv-scope="basic" :danger-text="errors.first('basic.contactNumber')"
                v-model="supplierData.contactNumber" val-icon-danger="error"
                :danger="errors.first('basic.contactNumber')" />
            </vs-col>
          </vs-row>
          <vs-row vs-align="flex-start" vs-type="flex" vs-justify="left" vs-w="12">
            <vs-col vs-w="4">
              <div class="sageButton" ref="sageButton">
                  <vs-input state="success"  name="sageSupplierId" data-vv-as="Sage Supplier id" label="Sage Id"
                  class="custom-input w-full" data-vv-scope="basic" :danger-text="sageError"
                  val-icon-success="done"
                  loading
                  val-icon-danger="error"
                  :success-text="sageSuccess"
                  :success="sageSuccess ? true : false"
                  v-model="supplierData.sageSupplierId" 
                  @input="validateSageVendor"
                  :danger="sageError ? true : false" />
              </div>
              
            </vs-col>
          </vs-row>
        </div>
        <vs-divider></vs-divider>
        <div class="custom-form py-4">
          <div class="py-4">
            <h6 class="font-bold">Delivery fee</h6>
          </div>
          <vs-row vs-align="flex-start" vs-type="flex" vs-justify="left" vs-w="12">
            <vs-col vs-w="4">
              <vs-input class="custom-input w-full" :success="
                !errors.first('basic.deliveryFee') &&
                supplierData.deliveryDetails.deliveryFee != ''
              " val-icon-success="done" val-icon-danger="error"
                :danger="errors.first('basic.deliveryFee')" v-validate="'required|decimal:3'"
                name="deliveryFee" data-vv-as="Delivery fee" label="Default delivery fee" data-vv-scope="basic"
                :danger-text="errors.first('basic.deliveryFee')" v-model="supplierData.deliveryDetails.deliveryFee" />
            </vs-col>
          </vs-row>
          <vs-row vs-align="flex-start" vs-type="flex" vs-justify="left" vs-w="12" v-if="isVisible">
            <vs-col vs-w="4">
              <vs-button :disabled="isDisabled" type="flat" icon-pack="feather" icon="icon-plus" class="p-0"
                @click="showModal = !showModal">Add
                shipping fee rule</vs-button>
            </vs-col>
          </vs-row>
          <vs-row vs-w="12" v-if="!showAddBtn">
            <vs-col vs-w="6">
              <div class="custom-rule p-4">
                <vs-row vs-align="flex-start" vs-type="flex" vs-justify="left" vs-w="12">
                  <vs-col vs-w="12">
                    <vs-input :success="true" val-icon-success="done"
                      label="If at checkout the cart $ value of this suppliers products is equal to or greater than:"
                      class="custom-input w-full mb-1" v-model="supplierData.rule.minimumOrder" readonly="readonly" />
                  </vs-col>
                </vs-row>
                <vs-row vs-align="flex-start" vs-type="flex" vs-justify="left" vs-w="12">
                  <vs-col vs-w="12">
                    <vs-input :success="true" val-icon-success="done" label="Update shipping fee for supplier to be"
                      class="custom-input w-full mb-1" v-model="supplierData.rule.discountedPrice" readonly="readonly" />
                  </vs-col>
                </vs-row>
                <vs-row vs-type="flex" vs-align="space-around" vs-w="12">
                  <vs-col vs-w="6">
                    <vs-button size="small" type="border" @click="edit()">Edit shipping rule</vs-button>
                  </vs-col>
                  <vs-col vs-w="6" class="text-right">
                    <vs-button size="small" type="border" color="danger" @click="remove()">Remove</vs-button>
                  </vs-col>
                </vs-row>
              </div>
            </vs-col>
          </vs-row>
          <vs-row vs-align="flex-start" vs-type="flex" vs-justify="left" vs-w="12" class="mt-4">
            <vs-col vs-w="12">
              <p class="text-sm font-semibold">Stacked delivery fee</p>
              <p class="text-xs mb-2">Added once per order on top of the delivery fee when the cart has a product
                marked with this fee (e.g. Cold chain). Leave the amount at 0 to turn it off.</p>
            </vs-col>
          </vs-row>
          <vs-row v-if="feeMainSupplier" vs-align="flex-start" vs-type="flex" vs-justify="left" vs-w="12">
            <vs-col vs-w="12">
              <p class="text-xs text-warning mb-2">Delivery fees for this supplier come from the main supplier
                <strong>{{ feeMainSupplier.name }}</strong>. Set the stacked delivery fee there.</p>
            </vs-col>
          </vs-row>
          <vs-row v-else vs-align="flex-start" vs-type="flex" vs-justify="left" vs-w="12">
            <vs-col vs-w="4" class="pr-2">
              <vs-input class="custom-input w-full" name="stackedDeliveryFeeLabel" label="Label"
                placeholder="e.g. Cold chain" data-vv-scope="basic" v-model="supplierData.stackedDeliveryFee.label" />
            </vs-col>
            <vs-col vs-w="4">
              <vs-input class="custom-input w-full" name="stackedDeliveryFeeAmount" label="Amount"
                data-vv-as="Stacked delivery fee" data-vv-scope="basic" v-validate="'decimal:2|min_value:0'"
                :danger="errors.first('basic.stackedDeliveryFeeAmount') ? true : false"
                :danger-text="errors.first('basic.stackedDeliveryFeeAmount')"
                v-model="supplierData.stackedDeliveryFee.amount" />
            </vs-col>
          </vs-row>
        </div>
        <vs-divider></vs-divider>
        <div class="custom-form py-4">
          <div class="py-4 pb-6">
            <h6 class="font-bold">Supplier access</h6>
          </div>
          <vs-row vs-align="flex-start" vs-type="flex" vs-justify="left" vs-w="12">
            <vs-col vs-w="12">
              <vs-checkbox v-model="supplierData.isInstant">
                <p class="text-xs font-semibold text-black">Instant access</p>
              </vs-checkbox>
              <div class="pl-8">
                <p class="pl-1 text-xs text-black">Active - All store accounts have instant access to
                  this
                  supplier
                </p>
                <p class="pl-1 text-xs text-black">Inactive - This supplier must be toggled on for each
                  clinic
                  manually through clinic settings
                </p>
              </div>
            </vs-col>
          </vs-row>
        </div>
        <vs-divider></vs-divider>
        <div class="custom-form py-4">
          <div class="py-4 pb-6">
            <h6 class="font-bold">Main Supplier</h6>
          </div>
          <vs-row vs-align="flex-start" vs-type="flex" vs-justify="left" vs-w="12">
            <vs-col vs-w="12">
              <vs-checkbox v-model="isMainSupplier" @change="handleMainSupplierChange">
                <p class="text-xs font-semibold text-black">Main Supplier</p>
              </vs-checkbox>
              <div class="pl-8">
                <p class="pl-1 text-xs text-black">Check this box to view all related suppliers. Once checked, this supplier will be used as a reference for the delivery fee.
                </p>
              </div>
            </vs-col>
          </vs-row>
          <vs-row vs-align="flex-start" vs-type="flex" vs-justify="left" vs-w="12" v-if="isMainSupplier" class="mt-4">
            <vs-col vs-w="12">
              <div v-if="isLoadingRelatedSuppliers" class="text-center py-4">
                <vs-progress :indeterminate="true" color="primary"></vs-progress>
                <p class="text-xs text-gray-600 mt-2">Loading related suppliers...</p>
              </div>
              <div v-else-if="relatedSuppliers.length > 0">
                <h6 class="font-bold mb-3">Related Suppliers</h6>
                <div class="related-suppliers-list">
                  <div 
                    v-for="supplier in relatedSuppliers" 
                    :key="supplier.id" 
                    class="supplier-item p-3 mb-2 border rounded cursor-pointer hover:bg-gray-50 transition-colors"
                    @click="viewSupplier(supplier.id)"
                  >
                    <div class="flex justify-between items-center">
                      <div class="w-full">
                        <a 
                          href="javascript:void(0)" 
                          @click.stop="viewSupplier(supplier.id)"
                          class="font-semibold text-sm text-primary hover:underline block"
                        >
                          {{ supplier.name }}
                        </a>
                        <p class="text-xs text-gray-600 mt-1" v-if="supplier.sageSupplierId">
                          Sage ID: {{ supplier.sageSupplierId }}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div v-else>
                <p class="text-xs text-gray-600">No related suppliers found.</p>
              </div>
            </vs-col>
          </vs-row>
        </div>
        <vs-divider></vs-divider>
        <div class="custom-form py-4">
          <div class="py-4 pb-6">
            <h6 class="font-bold">Bundle Supplier</h6>
          </div>
          <vs-row vs-align="flex-start" vs-type="flex" vs-justify="left" vs-w="12">
            <vs-col vs-w="12">
              <div class="flex">
                <vs-switch v-model="supplierData.isBundledSupplier" />
                <div class="pl-1 pt-1">
                  <span class="text-xs font-semibold text-black">Is Bundle Supplier</span>
                  <p class="pl-1 text-xs text-black">Active - this supplier will be used as a placeholder
                    for bundle items supplier
                  </p>
                  <p class="pl-1 text-xs text-black">Inactive - This supplier is a regular supplier
                  </p>
                </div>
              </div>
            </vs-col>
          </vs-row>
        </div>
        <vs-divider></vs-divider>
        <div class="custom-form py-4">
          <div class="py-4 pb-6">
            <h6 class="font-bold">Supplier Onboard Link</h6>
          </div>
          <vs-row vs-align="flex-start" vs-type="flex" vs-justify="left" vs-w="12">
            <vs-col vs-w="4">
              <vs-input label="Onboard Link" name="supplierOnboardingLink" v-model="supplierData.supplierOnboardingLink" class="custom-input w-full"/>
            </vs-col>
          </vs-row>
        </div>

        <vs-divider></vs-divider>
        <div class="custom-form py-4 border-0">
          <div class="py-4 pb-6">
            <h6 class="font-bold">Category visibility</h6>
          </div>
          <vs-row vs-align="flex-start" vs-type="flex" vs-justify="left" vs-w="12">
            <vs-col vs-w="12">
              <vs-radio v-model="supplierData.privateStatus" :vs-value="false">
                <p class="text-xs font-semibold text-black">Public</p>
              </vs-radio>
              <div class="pl-4">
                <p class="pl-3 text-xs text-black">Default visibility. This will allow all clinics to
                  view this category.
                </p>
              </div>
            </vs-col>
          </vs-row>
          <vs-row vs-align="flex-start" vs-type="flex" vs-justify="left" vs-w="12" class="mt-5">
            <vs-col vs-w="12">
              <vs-radio v-model="supplierData.privateStatus" :vs-value="true">
                <p class="text-xs font-semibold text-black">Private</p>
              </vs-radio>
              <div class="pl-4">
                <p class="pl-3 text-xs text-black">This will only allow specific users associated to
                  this category to view it.
                </p>
              </div>
            </vs-col>
            <vs-col vs-w="4" v-if="supplierData.privateStatus" class="h-96 mt-1">
              <label class="text-xs py-1 px-0 block">Select Clinic</label>
              <v-select multiple :options="clinicList" :closeOnSelect="false" :clearable="false" v-validate="'required'"
                name="privateAssignedClinics" :dir="$vs.rtl ? 'rtl' : 'ltr'" v-model="assignedClinics" />
              <span class="text-danger text-xs">{{
                  errors.first("assignedClinicsIsError")
              }}</span>
            </vs-col>
          </vs-row>
        </div>
        <vs-divider></vs-divider>
        <div class="custom-form py-4 border-0">
          <div class="py-4 pb-6">
            <h6 class="font-bold">Available in</h6>
          </div>
          <vs-row vs-align="flex-start" vs-type="flex" vs-justify="left" vs-w="12">
            <vs-col vs-w="12">
              <vs-select
                autocomplete  
                class="w-1/3"
                placeholder="Select where available"
                v-model="supplierData.availableIn"
                >
                <vs-select-item  :key="index" :value="item.value" :text="item.label" v-for="(item,index) in supplierAvailableIn" />
              </vs-select>
            </vs-col>
          </vs-row>
        </div>
      </vs-form>
    </vs-card>
    <vs-popup class="holamundo shipping-fee-modal" title="Shipping fee rule" :active.sync="showModal">
      <vs-form autocomplete="off">
        <vs-row vs-align="flex-start" vs-type="flex" vs-justify="left" vs-w="12">
          <vs-col vs-w="12">
            <vs-input :success="!errors.first('rule.minOrder') && supplierData.name != ''" val-icon-success="done"
              val-icon-danger="error" :danger="errors.first('rule.minOrder')"
              v-validate="'required|decimal:3|min_value:1'" name="minOrder" data-vv-as="Minimum order"
              label="If at checkout the cart $ value of this suppliers products is equal to or greater than:"
              class="custom-input w-full" data-vv-scope="rule" :danger-text="errors.first('rule.minOrder')"
              v-model="supplierData.rule.minimumOrder" />
          </vs-col>
        </vs-row>
        <vs-row vs-align="flex-start" vs-type="flex" vs-justify="left" vs-w="12">
          <vs-col vs-w="12">
            <vs-input :success="!errors.first('rule.discount') && supplierData.name != ''" val-icon-success="done"
              val-icon-danger="error" :danger="errors.first('rule.discount')"
              v-validate="'required|decimal:3'" name="discount" data-vv-as="Discount"
              label="Update shipping fee for supplier to be" class="custom-input w-full" data-vv-scope="rule"
              :danger-text="errors.first('rule.discount')" v-model="supplierData.rule.discountedPrice" />
          </vs-col>
        </vs-row>
      </vs-form>
      <vs-divider></vs-divider>
      <vs-row vs-align="space-around" vs-type="flex" vs-w="12">
        <vs-col vs-w="6">
          <vs-button class="py-1 px-4" @click="cancelRule()" type="border">Cancel</vs-button>
        </vs-col>
        <vs-col vs-w="6" class="block text-right">
          <vs-button class="py-1 px-4 mr-1" @click="saveRule()">Apply</vs-button>
        </vs-col>
      </vs-row>


    </vs-popup>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import { SUPPLIER_AVAILABLE_IN } from '@/constants/supplier';
import vSelect from 'vue-select';
import axios from '@/axios.js';

export default {
  name: 'SupplierDetails',
  components: {
    vSelect,
  },
  props: [
    'supplierId',
    'onSave',
    'createOrUpdateSupplier',
    'isCreate',
  ],
  data() {
    return {
      popUpCreate:false,
      id: this.supplierId,
      isValidatingSupplier:true,
      supplierAvailableIn: [
        ...SUPPLIER_AVAILABLE_IN,
      ],
      sageError:'',
      sageSuccess:'',
      timeout:'',
      supplierData: {
        name: '',
        email: '',
        contactNumber: '',
        deliveryDetails: {
          deliveryFee: 0,
        },
        stackedDeliveryFee: {
          label: '',
          amount: 0,
        },
        isInstant: false,
        privateStatus: false,
        privateAssignedClinics: [],
        rule: {
          minimumOrder: 0,
          discountedPrice: 0,
        },
        sageSupplierId:'',
        supplierOnboardingLink: '',
        availableIn: 'none',
      },
      assignedClinics: [],
      clinicList: [],
      showModal: false,
      showAddBtn: true,
      assignedClinicsIsError: false,
      isMainSupplier: false,
      relatedSuppliers: [],
      isLoadingRelatedSuppliers: false,
    };
  },
  computed: {
    // A supplier that shares its Sage ID with a main supplier gets its delivery fees from that main supplier.
    feeMainSupplier() {
      if (this.isMainSupplier || !this.supplierData.sageSupplierId) return null;
      return this.relatedSuppliers.find((supplier) => supplier.isMainSupplier) || null;
    },
    validateForm() {
      return !this.errors.any();
    },
    isDisabled() {
      if (this.supplierData.deliveryDetails.deliveryFee <= 0 && this.supplierData.rule.minimumOrder <= 0) {
        return true;
      }
      return false;
    },
    isVisible() {
      if (this.supplierData.rule.minimumOrder <= 0) {
        return true;
      }
      return false;
    },
  },
  mounted() { },
  watch: {
    onSave: function (isSave) {
      if (isSave) {
        this.saveDetails();
      }
    },
    'supplierData.privateStatus': function (curr) {
      if (curr && !this.clinicList.length) {
        this.getAllClinics();
      }
    },
    supplierId: {
      handler(newSupplierId) {
        if (newSupplierId && newSupplierId !== this.id) {
          this.id = newSupplierId;
          this.fetchSupplierDetails(newSupplierId);
        }
      },
      immediate: false,
    },
  },
  methods: {
    ...mapActions('supplier', ['getSupplierDetails', 'getRelatedSuppliers']),
    ...mapActions('clinic', ['fetchAllClinic']),

    async fetchSupplierDetails(id) {
      this.$vs.loading();
      await this.getSupplierDetails(id).then(res => {
        this.supplierData = res.data.data;
        this.supplierData = {
          ...this.supplierData,
          privateStatus: this.supplierData.privateStatus ? this.supplierData.privateStatus : false,
          rule: this.supplierData.rule ? { minimumOrder: this.supplierData.rule.minimumOrder / 100, discountedPrice: this.supplierData.rule.discountedPrice / 100 } : { minimumOrder: 0, discountedPrice: 0 },
          isInstant: this.supplierData.isInstant ? this.supplierData.isInstant : false,
          email: this.mapEmail(this.supplierData),
          deliveryDetails: {
            deliveryFee: this.getDeliveryFee(this.supplierData),
          },
          stackedDeliveryFee: this.getStackedDeliveryFee(this.supplierData),
        };
        if (this.supplierData.rule.minimumOrder > 0) {
          this.showAddBtn = false;
        }

        // Initialize isMainSupplier from fetched data
        this.isMainSupplier = this.supplierData.isMainSupplier || false;

        // Use relatedSuppliers from response if available
        if (res.data.data.relatedSuppliers && Array.isArray(res.data.data.relatedSuppliers)) {
          this.relatedSuppliers = res.data.data.relatedSuppliers;
        } else {
          this.relatedSuppliers = [];
        }

        this.getSageSupplierInfo();
        
        this.$vs.loading.close();
      });
    },
    mapEmail(data) {
      if (data.email) {
        return data.email.map(email => email.trim()).join(',');
      }
      return '';
    },
    getStackedDeliveryFee(data) {
      const fee = data.stackedDeliveryFee || {};
      return {
        label: fee.label || '',
        amount: (fee.amount || 0) / 100,
      };
    },
    getDeliveryFee(data) {
      if (data.deliveryDetails && data.deliveryDetails.deliveryFee) {
        return data.deliveryDetails.deliveryFee / 100;
      }
      return 0;
    },
    getAllClinics() {
      this.$vs.loading();
      this.fetchAllClinic()
        .then(async res => {
          this.$vs.loading.close();
          this.clinicList = [...res.data.data].map(({ clinicName: label, id: value }) => ({ label, value }));
          this.supplierData.privateAssignedClinics.forEach((item) => {
            let clinic = this.clinicList.find(
              (clinicObj) => clinicObj.value === item
            );
            this.assignedClinics.push(clinic);
          });
          this.$vs.loading.close();
        });
    },
    async saveRule() {
      const validRule = await this.$validator.validateAll('rule');
      if (validRule) {
        this.showModal = false;
        this.showAddBtn = false;
      }
    },
    cancelRule() {
      this.showModal = false;
      if (this.showAddBtn) {
        this.supplierData.rule = {
          minimumOrder: 0,
          discountedPrice: 0,
        };
      }
    },
    edit() {
      this.showModal = true;
    },
    remove() {
      this.supplierData.rule = {
        minimumOrder: 0,
        discountedPrice: 0,
      };
      this.showAddBtn = true;
    },
    async saveDetails() {
      /* eslint-disable */
      this.isValid = await this.$validator.validateAll("basic");

      if (
        this.supplierData.privateStatus && !this.assignedClinics.length
      ) {
        this.isValid = false;
        this.errors.add({
          field: "assignedClinicsIsError",
          msg: "Clinic/s must be assigned if supplier is private",
        });
      }

      if (!this.isValid || this.sageError) {
        this.$vs.notify({
          title: "Error",
          text: "Validation Failed",
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "danger",
        });
        return false;
      } else {
        if (!this.supplierData.sageSupplierId) {
            this.popUpCreate = true
        } else {
            this.saveSupplier()
        }

        this.errors.remove("assignedClinicsIsError");
      }
    },
    saveSupplier() {
        const data = {
          ...this.supplierData,
          deliveryDetails: {
            deliveryFee: parseFloat(this.supplierData.deliveryDetails.deliveryFee) * 100
          },
          stackedDeliveryFee: {
            label: (this.supplierData.stackedDeliveryFee.label || '').trim(),
            amount: Math.round((parseFloat(this.supplierData.stackedDeliveryFee.amount) || 0) * 100),
          },
          email: this.supplierData.email.split(","),
          privateAssignedClinics: this.assignedClinics.map(({ value: _id }) => ({ _id })),
          rule: {
            minimumOrder: parseFloat(this.supplierData.rule.minimumOrder) * 100,
            discountedPrice: parseFloat(this.supplierData.rule.discountedPrice) * 100
          },
          trackingOptions: [],
          isMainSupplier: this.isMainSupplier
        }
        this.popUpCreate = false
        this.$emit("createOrUpdateSupplier", data);
    },
    async validateSageVendor() {
        if (this.timeout) 
            clearTimeout(this.timeout); 

        this.timeout = setTimeout(async () => {
            this.getSageSupplierInfo()
        }, 1000); // delay
    },
    async getSageSupplierInfo() {
        try {
            if (!this.supplierData.sageSupplierId) {
                this.sageSuccess = ''
                this.sageError = ''
                return
            }

            this.$vs.loading();

            const {data} = await axios.get(`/api/v1/store/suppliers/sageDetails/${this.supplierData.sageSupplierId}`)
            
            if (data && data.data && data.data.NAME) {
                this.sageSuccess = `Supplier ID ${this.supplierData.sageSupplierId} corresponds to an entity named ${data ? data.data.NAME : ''} on the Sage platform.`
                this.sageError = ''
            } else {
                this.sageSuccess = ''
                this.sageError = `The supplier with ID ${this.supplierData.sageSupplierId} does not exist on the Sage platform.`
            }
        } catch {
            this.sageSuccess = ''
            this.sageError = `The supplier with ID ${this.supplierData.sageSupplierId} does not exist on the Sage platform.`
        } finally {
            this.$vs.loading.close();
        }
    },
    handleCancel() {
      this.$router.push({ name: "superAdminStoreSuppliers" });
    },
    onSave() {
      this.saveDetails();
    },
    async handleMainSupplierChange() {
      // Prevent duplicate calls if already loading
      if (this.isLoadingRelatedSuppliers) return;
      
      if (this.isMainSupplier && this.id) {
        // Always validate via API when marking as main supplier (even if we already have relatedSuppliers)
        await this.fetchRelatedSuppliers();
      } else {
        this.relatedSuppliers = [];
      }
    },
    async fetchRelatedSuppliers() {
      if (!this.id) return;
      
      // Prevent duplicate calls if already loading
      if (this.isLoadingRelatedSuppliers) return;
      
      this.isLoadingRelatedSuppliers = true;
      try {
        const res = await this.getRelatedSuppliers(this.id);
        if (res && res.data && res.data.data) {
          this.relatedSuppliers = res.data.data;
        } else {
          this.relatedSuppliers = [];
        }
      } catch (error) {
        console.error('Error fetching related suppliers:', error);
        let errorMessage = 'Failed to fetch related suppliers';
        let errorTitle = 'Error';
        
        // Handle both cases: error.response (full error) or error (response from interceptor)
        let errorData = null;
        if (error.response && error.response.data) {
          // Full error object with response property
          errorData = error.response.data;
        } else if (error.data) {
          // Error is already the response object (from axios interceptor)
          errorData = error.data;
        }
        
        // Extract error message from response
        if (errorData) {
          if (errorData.message) {
            errorMessage = errorData.message;
          } else if (errorData.error) {
            errorMessage = errorData.error;
          } else if (typeof errorData === 'string') {
            errorMessage = errorData;
          }
          
          // Extract error title
          if (errorData.title) {
            errorTitle = errorData.title;
          }
        } else if (error.message) {
          errorMessage = error.message;
        }
        
        this.$vs.notify({
          title: errorTitle,
          text: errorMessage,
          color: 'danger',
        });

        // Revert checkbox with a small delay so the user can see what happened
        setTimeout(() => {
          this.isMainSupplier = false;
          this.relatedSuppliers = [];
        }, 800);
      } finally {
        this.isLoadingRelatedSuppliers = false;
      }
    },
    viewSupplier(supplierId) {
      this.$router.push({
        name: 'superAdminStoreViewSuppliers',
        params: { supplierId: supplierId },
      });
    },
  },
 
  async created() {
    this.id = this.supplierId;
    if (this.id) {
      await this.fetchSupplierDetails(this.id);
    }
  },
};
</script>

<style>
.shipping-fee-modal .vs-popup--header .vs-popup--title h3 {
  display: block !important;
}

.shipping-fee-modal .vs-popup .vs-popup--content {
  padding: 1rem !important;
  margin: 5px 5px 5px !important;
}

.custom-input {
  margin-bottom: 20px;
}

.custom-input label {
  display: block;
  padding: 5px 0;
}

.stretch-width {
  width: 100vw;
  margin-left: 50%;
  transform: translateX(-50%);
  max-width: 100%;
}

.custom-rule {
  border: solid 1px #28c76f;
  border-radius: 5px;
  background-color: #f0f0f0;
}
</style>
